import { Box, InputLabel, Typography } from "@mui/material";
import CustomInput from "../../../../../../components/CustomInput";
import OtpInput from "../../../OtpInput";

import React, { useState } from "react";
import CustomSelectOption, {
  Ioption,
} from "../../../../../../components/CustomSelectOption";
import { useFormik } from "formik";
import CustomInputLabel from "../../../../../../components/CustomInputLabel";

export default function ManagerInfo() {
  const [otpState, setOtpState] = useState(true);
  const [months, setMonths] = useState<Ioption[]>([]);

  const mymonths = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];

  const formik = useFormik({
    initialValues: {
      dateOfBrith: {
        jy: 1300,
        jm: 8,
        jd: 26,
      },
    },
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const handleDateOfBrith = (value: any, selectFor: string) => {
    switch (selectFor) {
      case "year":
        formik.setFieldValue("dateOfBrith", {
          ...formik.values.dateOfBrith,
          jy: value,
        });

        break;
      case "month":
        formik.setFieldValue("dateOfBrith", {
          ...formik.values.dateOfBrith,
          jm: value,
        });

        break;
      case "day":
        formik.setFieldValue("dateOfBrith", {
          ...formik.values.dateOfBrith,
          jd: value,
        });

        break;

      default:
        break;
    }
  };

  return (
    <>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontWeight: "600",
          color: "secondary.main",
        }}
        variant="h3"
      >
        مشخصات مدیرعامل{" "}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <Box
          sx={{
            flex: "1",
            // overflow: "auto",
            px: 1,
            // maxHeight: {
            //   xs: "auto",
            //   sm: "400px",
            //   md: "300px",
            //   lg: "300px",
            //   xl: "500px",
            // }, // Limiting the height
          }}
        >
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"نام و نام‌خانوادگی مدیرعامل"}
            </CustomInputLabel>

            <CustomInput placHolder="نام شرکت را وارد کنید..." />
          </Box>
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کد ملی مدیرعامل"}
            </CustomInputLabel>

            <CustomInput placHolder="نام شرکت را وارد کنید..." />
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"سال تولد:"}
              </InputLabel>
              <CustomSelectOption
                selectFor={"year"}
                handleChange={handleDateOfBrith}
                options={new Array(80).fill(1).map((item, index) => ({
                  label: 1300 + index,
                  value: 1300 + index,
                }))}
                value={formik.values.dateOfBrith.jy}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"ماه تولد:"}
              </InputLabel>

              <CustomSelectOption
                selectFor="month"
                handleChange={handleDateOfBrith}
                value={formik.values.dateOfBrith.jm}
                options={months}
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <InputLabel
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  marginBottom: "8px",
                  fontSize: "14px",
                }}
                htmlFor="outlined-adornment-amount"
              >
                {"روز تولد:"}
              </InputLabel>

              <CustomSelectOption
                selectFor="day"
                handleChange={handleDateOfBrith}
                value={formik.values.dateOfBrith.jd}
                options={new Array(30).fill(1).map((item, index) => ({
                  label: index + 1,
                  value: index + 1,
                }))}
              />
            </Box>
          </Box>

          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"تلفن همراه مدیرعامل"}
            </CustomInputLabel>

            <CustomInput placHolder="تلفن همراه مدیرعامل را وارد کنید..." />
          </Box>

          {otpState && <OtpInput />}
        </Box>
      </Box>
    </>
  );
}
